
const apiConfig = {
                       baseURL: "https://api.dicebd.com",
                    //  baseURL: "http://localhost:5000",
                  };

export default apiConfig;